import LegalPage from '../components/LegalPage'
import policy from '../../../legal/acceptable-use-policy.md?raw'

export default function AcceptableUse() {
  return <LegalPage markdown={policy} title="Acceptable Use Policy" />
}
